<template>
    <div>
        <!-- 过滤条件 -->
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 4px"
        >
            <form-lookup
                style="
                    min-width: 262px;
                    margin-right: 15px;
                    max-height: 90px;
                    overflow: auto;
                "
                v-model="selectRoom.roomId"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                :options.sync="selectRoom.roomList"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room multiple />
            </form-lookup>
            <!-- 选择排序 -->
            <Select
                style="width: 200px; margin-right: 15px"
                v-model="filter.orderBys"
                placeholder="排序类型"
                @on-change="search"
            >
                <Option
                    v-for="item in orderBysList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <!-- 高级搜索 -->
            <bill-adv-search
                ref="adv"
                v-model="advFilter"
                :name="accessName"
                @confirm="onAdvConfirm"
            ></bill-adv-search>
        </div>
        <!-- 已选中的搜索条件 -->
        <select-tags
            v-model="advOptions"
            style="margin-bottom: 4px"
            @close="onAdvItemClose"
        ></select-tags>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.cusUser"
                    placeholder="请输入客户姓名,手机号或单位名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            总额：
            <span style="font-size: 16px; padding-right: 10px">
                {{ totalAmount | currency }}
            </span>
            <Button
                v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
            >
                新增账单
            </Button>
            <Button
                v-if="$can('batchPayment')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickBatchPayment"
            >
                批量付款
            </Button>
            <Button
                v-if="$can('batchToVoid')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                @click="onClickBatchInvalid"
            >
                批量作废
            </Button>
            <Button
                v-if="$can('exportExcel')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                :loading="loadingExport"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
            @on-selection-change="selectionChange"
        >
            <template v-slot:billStatusText="{ row }">
                <tag-status
                    v-if="row.overdue === 0"
                    :text="row.billStatusText"
                    :color="row.billStatusColor"
                    :background="row.billStatusBgc"
                    circle
                />
                <tag-status
                    v-else
                    :text="`逾期${row.overdue}天`"
                    color="#EE870D"
                    background="#F9F2E9"
                    circle
                />
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickView(row)"
                >
                    详情
                </Button>
                <Button
                    v-if="$can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickUpdate(row)"
                >
                    修改
                </Button>
                <Button
                    v-if="$can('payment')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickPayment(row)"
                >
                    付款
                </Button>
                <Dropdown
                    transfer
                    @on-click="
                        (name) => {
                            changeAction(name, row)
                        }
                    "
                >
                    <Button
                        type="default"
                        size="small"
                        v-if="
                            (row.feeType === '6' && $can('migrate')) ||
                            (row.isViewContract && $can('viewContract')) ||
                            $can('toVoid')
                        "
                    >
                        更多
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem
                            v-if="row.feeType === '6' && $can('migrate')"
                            name="addrMigrate"
                        >
                            地址迁移
                        </DropdownItem>
                        <DropdownItem
                            name="contractView"
                            v-if="row.isViewContract && $can('viewContract')"
                        >
                            查看合同
                        </DropdownItem>
                        <DropdownItem name="billInvalid" v-if="$can('toVoid')">
                            作废账单
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showAddrMigrateForm"
            title="地址迁移"
            :width="800"
            :height="360"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <bill-addr-migrate-form
                v-if="modal.showAddrMigrateForm"
                :contractId="contractId"
                :migrate="migrate"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showBillForm"
            :title="actionTitle + '账单'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <bill-form
                v-if="modal.showBillForm"
                :id="curId"
                :depositOffset="depositOffset"
                :offsetAmount="offsetAmount"
                billStatus="3"
                :actionType="actionType"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showBillPaymentForm"
            title="账单付款"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <bill-payment-df-form
                v-if="modal.showBillPaymentForm"
                :id="curId"
                :depositOffset="depositOffset"
                :offsetAmount="offsetAmount"
                billStatus="3"
            />
        </smart-modal>
        <smart-modal
            v-model="modal.showBillBatchPaymentForm"
            title="账单批量付款"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <bill-batch-payment-form
                v-if="modal.showBillBatchPaymentForm"
                :id="curId"
                :amount="amount"
                billStatus="3"
            />
        </smart-modal>
        <!-- 弹出框-提示 -->
        <alter :text="modalMsg" v-model="alterShow" @closeAlter="closeAlter" />
        <!-- 提示信息——作废账单 -->
        <confirm
            :text="modalMsg"
            v-model="modal.confirmShowInvalid"
            :id="curId"
            @closeModal="closeModalInvalid"
            @confirmModal="confirmModalInvalid"
        />
        <!-- 提示信息——批量作废账单 -->
        <confirm
            :text="modalMsg"
            v-model="modal.confirmShowBatchInvalid"
            :id="curId"
            @closeModal="closeModalBatchInvalid"
            @confirmModal="confirmModalBatchInvalid"
        />
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { currency, ymd } from '_u/helper'
import {
    getResAmountText,
    renderBillAmountText,
} from '@/views/common/u-contract'

import mBillList from '_v/common/m-bill-list'
import SelectRoom from '_vc/select-room'
import TagStatus from '_vc/tag-status'
import Alter from '_v/components/alter'
import Confirm from '_v/components/confirm'
import BillForm from './bill-form'
import BillPaymentDfForm from './bill-payment-df-form'
import BillBatchPaymentForm from './bill-batch-payment-form'
import BillAddrMigrateForm from './bill-addr-migrate-form'
import FilterDateRange from '_v/components/filter/filter-date-range'

import { billList, billInvalid, billBatchInvalid } from '@/api/bill'

export default {
    name: 'bill-df-list',
    mixins: [mBillList],
    components: {
        SelectRoom,
        TagStatus,
        Alter,
        Confirm,
        BillForm,
        BillPaymentDfForm,
        BillBatchPaymentForm,
        BillAddrMigrateForm,
        FilterDateRange,
    },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            loadingExport: false,
            curId: '',
            contractId: '',
            actionType: '', // 1 新增; 2 查看; 3 修改;
            page: {
                total: 0,
                list: [],
            },
            billStatusList: [], // 已付账单状态
            selectionList: [], // 当前选中项
            operation: 1,
            alterShow: false, // 是否显示弹出框
            modalMsg: '', // 提示框内容
            amount: 0, // 批量收款金额
            migrate: '', // 是否迁移
            depositOffset: '', // 定金抵扣方式
            offsetAmount: '', // 定金金额
            modal: {
                showBillForm: false,
                showBillPaymentForm: false,
                showBillBatchPaymentForm: false,
                confirmShowInvalid: false,
                showAddrMigrateForm: false,
                confirmShowBatchInvalid: false,
            },
            dict: {
                billStatus: this.$dict.NULL,
                feeType: this.$dict.NULL,
                actionType: this.$dict.NULL,
            },
            totalAmount: 0,
        }
    },

    computed: {
        ...mapCache({
            filter: 'dfFilter',
            advFilter: 'dfAdvFilter',
            advOptions: 'dfAdvOptions',
            selectRoom: 'dfSelectRoom',
        }),

        columns() {
            return [
                {
                    type: 'selection',
                    align: 'center',
                    width: 50,
                },
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    minWidth: 60,
                },
                {
                    key: 'houseName',
                    title: '房源名称',
                    align: 'left',
                    minWidth: 160,
                    tooltip: true,
                },
                {
                    key: 'cusUser',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 100,
                    tooltip: true,
                },
                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'feeTypeText',
                    title: '费用类型',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'periodText',
                    title: '当前账期',
                    align: 'center',
                    minWidth: 240,
                },
                {
                    key: 'planAmount',
                    title: '应付金额(元)',
                    align: 'right',
                    minWidth: 150,
                    render: (h, params) => {
                        const obj = {
                            amount: params.row.planAmount.split('\r\n'),
                            update: params.row.update,
                        }
                        return renderBillAmountText(h, obj, 'div', 'div')
                    },
                    className: 'bill-df-list-planAmount',
                },
                {
                    key: 'billStatusText',
                    title: '账单状态',
                    align: 'center',
                    minWidth: 150,
                    slot: 'billStatusText',
                },
                {
                    key: 'planDate',
                    title: '应付款日',
                    align: 'center',
                    width: 120,
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 240,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },

        actionTitle() {
            return this.dict.actionType.val(this.actionType)
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([
                billList(
                    Object.assign(
                        {},
                        this.filter,
                        this.normalizeAdvFilter(this.advFilter)
                    )
                ),
                this.$dict.get(['bill_status', 'fee_type', 'action_type']),
            ])
                .then((args) => {
                    var [view, group] = args

                    Object.assign(this.dict, group)

                    this.billStatusList = this.dict.billStatus
                        .toList()
                        .filter((v) => {
                            const remark = JSON.parse(v.remark)
                            return remark.type === 'df'
                        })
                    if (view.data.page) {
                        this.page.list = this.normalizePageData(
                            view.data.page.list
                        )
                        this.page.total = parseInt(view.data.page.totalCount)
                        this.totalAmount = view.data.totalAmount / 100
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        normalizePageData(list) {
            const billStatusDict = this.dict.billStatus
            const feeTypeDict = this.dict.feeType

            list.forEach((v) => {
                v.periodText = ''
                if (v.period && v.startDate && v.endDate) {
                    v.periodText = `第${v.period}期(${v.startDate} 至 ${v.endDate})`
                }
                v.planAmount =
                    currency(v.planAmount / 100) + getResAmountText(v)
                v.feeTypeText = feeTypeDict.val(v.feeType)
                const status = billStatusDict.get(v.billStatus)
                v.billStatusText = status.text
                v.billStatusColor = JSON.parse(status.remark).color
                v.billStatusBgc = JSON.parse(status.remark).background

                // 是否可以查看合同（只有定金且未签合同才不显示）
                v.isViewContract =
                    !v.contractId && v.feeType === '14' ? false : true
                const planDate = new Date(v.planDate)
                const nowDate = new Date(ymd(new Date()))
                if (planDate < nowDate) {
                    v.overdue = (nowDate - planDate) / (1000 * 60 * 60 * 24)
                } else {
                    v.overdue = 0
                }
            })

            return list
        },
        // 新增
        onClickAdd(e) {
            this.actionType = '1'
            this.curId = ''
            this.depositOffset = ''
            this.offsetAmount = ''
            this.modal.showBillForm = true
        },
        // 批量收款
        onClickBatchPayment() {
            this.operation = 1
            if (this.selectionList.length === 0) {
                this.modalMsg = '请至少选择一个账单再进行批量操作'
                this.alterShow = true
                return
            }
            const idList = []
            let amount = 0
            this.selectionList.forEach((v) => {
                idList.push(v.id)
                amount += v.amount - 0
            })
            this.curId = idList.join(',')
            this.amount = amount
            this.modal.showBillBatchPaymentForm = true
        },
        // 批量作废
        onClickBatchInvalid() {
            this.operation = 2
            if (this.selectionList.length === 0) {
                this.modalMsg = '请至少选择一个账单再进行批量操作'
                this.alterShow = true
                return
            } else {
                const idList = []
                this.selectionList.forEach((v) => {
                    idList.push(v.id)
                })
                this.curId = idList.join(',')
                this.modalMsg = '账单作废后无法撤回，是否确定？'
                this.modal.confirmShowBatchInvalid = true
            }
        },
        // 确定批量作废
        confirmModalBatchInvalid(id) {
            billBatchInvalid(id).then(() => {
                this.$Message.success('账单作废成功')
                this.search()
                this.modal.confirmShowBatchInvalid = false
            })
        },
        // 取消批量作废
        closeModalBatchInvalid() {
            this.modal.confirmShowBatchInvalid = false
        },
        // 导出Excel
        onClickExport() {
            this.loadingExport = true

            billList(
                Object.assign(
                    {},
                    this.filter,
                    this.normalizeAdvFilter(this.advFilter),
                    {
                        pageNo: 1,
                        pageSize: -1,
                    }
                )
            )
                .then((res) => {
                    var $mt = this.$refs.mt
                    $mt.exportToExcel({
                        rows: this.normalizePageData(res.data.page.list),
                    })
                })
                .finally(() => {
                    this.loadingExport = false
                })
        },
        // 详情
        rowClickView(row) {
            this.actionType = '2'
            this.curId = row.id
            this.depositOffset = row.depositOffset
            this.offsetAmount = row.offsetAmount
            this.modal.showBillForm = true
        },

        // 修改
        rowClickUpdate(row) {
            this.actionType = '3'
            this.curId = row.id
            this.depositOffset = row.depositOffset
            this.offsetAmount = row.offsetAmount
            this.modal.showBillForm = true
        },
        // 收款
        rowClickPayment(row) {
            this.curId = row.id
            this.depositOffset = row.depositOffset
            this.offsetAmount = row.offsetAmount
            this.modal.showBillPaymentForm = true
        },
        // 更多
        changeAction(name, row) {
            console.log(name, row)
            this[name](row)
        },
        // 地址迁移
        addrMigrate(row) {
            this.contractId = row.contractId
            this.migrate = row.migrate
            this.modal.showAddrMigrateForm = true
        },
        // 查看合同
        contractView(row) {
            this.$router.push({
                name: 'contractViewIndex',
                query: { contractId: row.contractId, type: '5' },
            })
        },
        // 作废账单
        billInvalid(row) {
            this.curId = row.id
            this.modalMsg = '账单作废后无法撤回，是否确定？'
            this.modal.confirmShowInvalid = true
        },
        // 确定作废
        confirmModalInvalid(id) {
            billInvalid(id).then(() => {
                this.$Message.success('账单作废成功')
                this.search()
                this.modal.confirmShowInvalid = false
            })
        },
        // 取消作废
        closeModalInvalid() {
            this.modal.confirmShowInvalid = false
        },

        // 选中项发生改变
        selectionChange(selection) {
            this.selectionList = selection
        },
        // 关闭 alter
        closeAlter() {
            this.alterShow = false
        },
        // 改变位置
        handleMousemove(row) {
            const list = this.page.list
            const index = list.findIndex((v) => v.id === row.id)
            this.placement =
                index !== -1 && index + 1 === list.length ? 'top' : 'bottom'
        },
    },
}
</script>
<style lang="less">
td.bill-df-list-planAmount {
    background-color: #e3f5fe;
}
</style>
